import styled from "styled-components";
import { FaFacebook, FaLinkedin, FaGoogle } from 'react-icons/fa'
import { AppContext } from "../App";
import {useContext} from 'react';
import { colors } from "../stylingVariables";

const ICON_SIZE = 30;

const StyledWrapper = styled.div`
  display: flex;
	justify-content: center;
	align-items: center;
`;
	
const StyledLogoContainer = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
	gap: 24px;
`;

const SocialIconBar = () => {
  const { state } = useContext(AppContext);
	const openLinkInNewTab = (link) => window.open(link, '_blank');
	
	return (
		<StyledWrapper>
			<StyledLogoContainer>
				<FaFacebook className={'social-media-icon'} color={colors.cyan} size={ICON_SIZE} onClick={() => openLinkInNewTab(state.socialMedia.facebook)}/>
				<FaLinkedin className={'social-media-icon'} color={colors.cyan} size={ICON_SIZE} onClick={() => openLinkInNewTab(state.socialMedia.linkedIn)}/>
				<FaGoogle className={'social-media-icon'} color={colors.cyan} size={ICON_SIZE} onClick={() => openLinkInNewTab(state.socialMedia.google)}/>
			</StyledLogoContainer>
		</StyledWrapper>
	)
}

export default SocialIconBar;